import React, { useState, useEffect, useContext } from "react";
import { ContextAuth } from "../../../contexts/ContextAuth";
import { getCurrentDate } from "../../../configs/helpers";
import { NewOrderPurchaseOperationForm } from "../fragments.buys/NewOrderPurchaseOperationForm";
import { NewOrderPurchaseOperationDetailForm } from "../fragments.buys/NewOrderPurchaseOperationDetailForm";
import { NewOrderPurchaseOperationDetailList } from "../fragments.buys/NewOrderPurchaseOperationDetailList";
import { fetchedOrderPurchaseByID } from "../../../apis/apis.logistics/apisProduct";
import { ConcludeOrderPurchaseForm } from "../fragments.buys/ConcludeOrderPurchaseForm";
import { ConcludeOrderPurchaseList } from "../fragments.buys/ConcludeOrderPurchaseList";
import {useParams} from "react-router"
import { initialOrderState, initialOptionState } from "../../../configs/OrderPurchaseStates";

export function ConcludeOrderPurchasePage() {
    let {id} = useParams();
    const [order, setOrder] = useState(initialOrderState);
    const [selectedOption, setSelectedOption] = useState(initialOptionState);
    const getOrderPurchase = async () => {
        try {
          const response = await fetchedOrderPurchaseByID({"operationID":id});
          setOrder(response)
          //return response;
        } catch (error) {
          throw error;
        }
      };

      useEffect(() => {
        getOrderPurchase();
      }, []);
      return (
        <>
          <section className="mb-6">
            <div className="max-w-full px-4">
              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                <h1 className="text-2xl font-bold text-gray-900 dark:text-white tracking-tight">
                  ORDENES DE COMPRA: VERIFICACIÓN
                </h1>
                <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
                  <span>Orden de Compras</span>
                  <span className="text-gray-400">/</span>
                  <span className="font-medium text-gray-900 dark:text-white">{id}</span>
                </div>
              </div>
            </div>
          </section>
          <section>
            <div className="max-w-full px-4">
              <ConcludeOrderPurchaseForm order={order} setOrder={setOrder} selectedOption={selectedOption} setSelectedOption={setSelectedOption} />
              <ConcludeOrderPurchaseList order={order} setOrder={setOrder} initialOrderState={initialOrderState} />
            </div>
          </section>
        </>
      )
}
